import { render } from "./HeroiconsSolidClock.vue?vue&type=template&id=7e583971"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidClock.vue"]])

export default __exports__